import { render, staticRenderFns } from "./QuickAccess.vue?vue&type=template&id=0d77319b&scoped=true&"
import script from "./QuickAccess.vue?vue&type=script&setup=true&lang=js&"
export * from "./QuickAccess.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./QuickAccess.vue?vue&type=style&index=0&id=0d77319b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d77319b",
  null
  
)

export default component.exports